/* src/app/service-item/posting-item/posting-item.component.scss */
body#themeTag :host {
  font-size: 1rem;
}
body#themeTag :host ::ng-deep .p-datatable.p-datatable-hoverable-rows .p-datatable-tbody > tr.p-selectable-row:not(.p-highlight):not(.p-contextmenu-selected):hover {
  background-color: #dddddd;
}
body#themeTag :host ::ng-deep .p-datatable.p-datatable-hoverable-rows .p-datatable-tbody > tr.p-selectable-row:not(.p-highlight):not(.p-contextmenu-selected):hover .p-datatable-cell.disabled {
  background-color: #dddddd;
}
body#themeTag :host ::ng-deep .p-datatable .p-datatable-tbody > tr > td.p-datatable-cell.p-editable-column.checkbox {
  padding: 0.25rem 0.31rem 0 0.31rem;
}
body#themeTag :host ::ng-deep .p-datatable .p-datatable-tbody > tr > td.p-datatable-cell .status-cell {
  width: 16px;
  height: 16px;
}
body#themeTag :host ::ng-deep .p-datatable .p-datatable-thead > tr > th .tabulator-header-filter p-multiselect {
  margin-bottom: -0.8rem;
}
/*# sourceMappingURL=posting-item.component.css.map */
